<div class="row justify-content-end properties-head">
    <!-- no possibility to save modifications for now
        <button class="btn btn-outline-info">Enregistrer</button> -->
</div>
<div class="view-item">
    <div class="form-group row">
        <label for="numserie" class="col-sm-3">Numéro de série : </label>
        <input type="text" id="numserie" name="numserie" value="{{machine.numero_serie}}" class="col-sm-2 form-control">
    </div>
    <div class="row">
        <div class="form-check col-sm-3">
            <input type="radio" class="form-check-input" name="porte" value="gauche" id="gauche" [checked]="left"><label for="gauche" class="form-check-label">Portes à gauche</label>
        </div>
        <div class="form-check col-sm-3">
            <input type="radio" class="form-check-input" name="porte" value="droite" id="droite" [checked]="!left"><label for="droite" class="form-check-label">Portes à droite</label>
        </div>
    </div>
</div>
<div class="view-item">
    <div class="form-check">
        <input type="checkbox" class="form-check-input" id="destruction" name="destruction">
        <label for="destruction" class="form-check-label">Cochez cette case si la machine a été détruite</label>
    </div>
    <div class="form-group row">
        <label for="destruction" class="col-sm-3">Date de la destruction : </label>
        <input type="text" class="col-sm-3 form-control" id="destruction" name="destruction" value="{{machine.date_destruction}}">
    </div>
</div>
<div class="view-item">
    <div class="form-group row">
        <label for="serie" class="col-sm-3">Série : </label>
        <input type="text" class="col-sm-3 form-control" id="serie" name="serie" value="{{machine.nom_serie}}" disabled>
    </div>
    <div class="form-group row">
        <label for="abreviation" class="col-sm-3">Abréviation : </label>
        <input type="text" class="form-control col-sm-3" id="abreviation" name="abreviation" value="{{machine.abbreviation}}" disabled>
    </div>
</div>
<div class="view-item">
    <div class="form-group row">
        <!-- Ne fait pas partie du SAV actuel mais on reçoit l'info, ça peut être utile -->
        <label for="version_progs" class="col-sm-3">Version des programmes : </label>
        <input type="text" class="form-control col-sm-3" id="version_progs" name="version_progs" value="{{machine.update_path}}" disabled>
    </div>
</div>
<!-- not saved for now
    <div class="view-item">
    <div class="form-check">
        <input type="checkbox" class="form-check-input" id="changement" name="changement">
        <label for="changement" class="form-check-label">Autoriser exceptionnelement tous les changements de matériel</label>
    </div>
</div> -->

